export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROm_CART";
export const FETCH_CART_SUCCEESS = "FETCH_CART_SUCCEESS";
export const FETCH_CART_LOADING = "FETCH_CART_LOADING";
export const FETCH_CART_ERROR = "FETCH_CART_ERROR";
export const SET_ADDTOCART_FALSE = "SET_ADDTOCART_FALSE";
export const SET_ADDTOCART_TRUE = "SET_ADDTOCART_TRUE";
export const SET_EMPTY = "SET_EMPTY";
